<template>
    <Pie
        :chart-options="chartOptions"
        :chart-data="chartData"
        :width="width"
        :height="height"
    />
</template>

<script>
    import { Pie } from 'vue-chartjs/legacy'

    import {
        Chart as ChartJS,
        Tooltip,
        Legend,
        ArcElement,
        CategoryScale
    } from 'chart.js'

    ChartJS.register(Tooltip, Legend, ArcElement, CategoryScale)

    export default {

        components: {
            Pie,
        },

        props: {
            width: {
                type: Number,
                default: 140
            },
            
            height: {
                type: Number,
                default: 80
            },
            
            data: {
                type: Object,
                required: true
            },
            
            position: {
                type: String,
                default: 'all'
            },
        },

        data() {
            return {
                chartOptions: {
                    responsive: false,
                    maintainAspectRatio: true,
                    elements: {
                        arc: {
                            borderWidth: 1
                        }
                    },
                    plugins: {
                        legend: {
                            display: true,
                            position: 'right',
                            align: 'middle',
                            labels: {
                                boxWidth: 10,
                                boxHeight: 10,
                                padding: 2,
                                generateLabels(chart) {
                                    const total = chart._metasets[0].total;
                                    return chart.data.datasets[0].data.map((currentValue, index) => {
                                        return {
                                            text: parseFloat((currentValue/total*100).toFixed(1)) + '%',
                                            fillStyle: chart.data.datasets[0].backgroundColor[index],
                                            strokeStyle: chart.data.datasets[0].backgroundColor[index],
                                            index: index
                                        }
                                    })
                                },
                                filter(legendItem, data) {
                                    return data.datasets[0].data[legendItem.index] > 0
                                }
                            }
                        },
                        tooltip: {
                            enabled: false,
                            callbacks: {
                                label(context){
                                    var label = context.label,
                                        currentValue = context.raw,
                                        total = context.chart._metasets[context.datasetIndex].total;

                                    var percentage = parseFloat((currentValue/total*100).toFixed(1));

                                    return label + ' ' + percentage + '%';
                                }
                            }
                        },
                    }
                },
            }
        },

        computed: {
            chartData() {
                let data = this.data[this.position]
                if (data == undefined) {
                    data = [0, 0, 0, 0, 0]
                } else {
                    // Be sure to represent all the values.
                    for (let rate = 0; rate < 5; rate++) {
                        if (data[rate] === undefined) {
                            data[rate] = 0
                        }
                    }
                    // Remove -1 value.
                    delete data[-1]
                    // Keep only the values
                    data = Object.values(data)
                }
                return {
                    labels: ['1', '2', '3', '4', '5'],
                    datasets: [
                        {
                            backgroundColor: ['#B4C2CC', '#F5365C', '#FBC340', '#11CDEF', '#2DCE89'],
                            data: data
                        }
                    ]
                }
            }
        }
    }
</script>
